import { useTranslation } from 'react-i18next';
import { JOB_APPLICATION__LINK_INACTIVE_BODY, JOB_APPLICATION__LINK_INACTIVE_TITLE } from 'translations/constants';
import { FormCard, PageIntro, PageTitle } from './styles';

/**
 * One state for every dead-link case — unknown token, revoked link, feature switched off. The API
 * answers all three identically on purpose: the reason would leak company information.
 */
const LinkNoLongerActive = (): JSX.Element => {
  const [t] = useTranslation();

  return (
    <FormCard>
      <PageTitle>{t(JOB_APPLICATION__LINK_INACTIVE_TITLE)}</PageTitle>
      <PageIntro>{t(JOB_APPLICATION__LINK_INACTIVE_BODY)}</PageIntro>
    </FormCard>
  );
};

export default LinkNoLongerActive;
